import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { PrescriptionModal } from '../components/PrescriptionModal';
import { Link } from 'react-router-dom';
export function Prescriptions() {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState<'refill' | 'transfer'>('refill');
  const openModal = (type: 'refill' | 'transfer') => {
    setModalType(type);
    setModalOpen(true);
  };
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="bg-white pb-20" data-id="element-513" data-mp="3hdw93f2fi94e">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 md:pt-20 mb-12 md:mb-16" data-id="element-514" data-mp="37hjhcmqg25ca">
        <h1 className="text-4xl font-extrabold text-slate-900 mb-8" data-id="element-515" data-mp="3cfuq0u5069sx">
          Prescription Services
        </h1>
        <p className="text-lg text-slate-600 mb-12 max-w-3xl" data-id="element-516" data-mp="2yg35sbnw7x6h">
          Manage your health with our comprehensive prescription services. We
          offer easy refills, transfers, and professional consultations.
        </p>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-517" data-mp="3eqffblk27bs3">
          <div className="p-8 bg-slate-50 rounded-2xl border border-slate-100" data-id="element-518" data-mp="3aqf3m8ocheoq">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-519" data-mp="3ashqiju7arp8">
              Refill a Prescription
            </h2>
            <p className="text-slate-600 mb-6" data-id="element-520" data-mp="3jr37iak0xynw">
              Quickly refill your existing prescriptions online for pickup at
              either of our locations.
            </p>
            <button onClick={() => openModal('refill')} className="bg-clinical-blue text-white font-bold py-3 px-6 rounded-xl hover:bg-blue-700 transition-all" data-id="element-521" data-mp="2vywdhi1ru3rn">
              Start Refill
            </button>
          </div>
          <div className="p-8 bg-slate-50 rounded-2xl border border-slate-100" data-id="element-522" data-mp="30yr7huguf9gx">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-523" data-mp="2d9ptzst5l84s">
              Transfer to Us
            </h2>
            <p className="text-slate-600 mb-6" data-id="element-524" data-mp="28b53wm7m84u2">
              Switching to Daily Care Pharmacy is simple. Provide your details
              and we'll handle the rest.
            </p>
            <Link to="/transfer-prescription" className="inline-block border-2 border-clinical-blue text-clinical-blue font-bold py-3 px-6 rounded-xl hover:bg-clinical-blue hover:text-white transition-all text-center" data-id="element-525" data-mp="h6l3qghs4xwc">
              Transfer Now
            </Link>
          </div>
        </div>
      </div>
      <PrescriptionModal isOpen={modalOpen} onClose={() => setModalOpen(false)} type={modalType} data-id="element-526" data-mp="3phej6ra6uppq" />
    </motion.div>;
}